import React, {useMemo} from "react";
import {ColumnDef, createColumnHelper} from "@tanstack/react-table";

export type ColumnData = {
  id: string;
  columnHeader: string;
  accessorFn: (row: any) => any;
};

type CreateColumnsProps<T> = {
  tableData: T[];
  columnData: ColumnData[];
};

export function useCreateColumns<T>({
  tableData,
  columnData,
}: CreateColumnsProps<T>): ColumnDef<T, any>[] {
  const columnHelper = createColumnHelper<any>();

  const columns = useMemo<ColumnDef<T, any>[]>(() => {
    return columnData.map((col) =>
      columnHelper.display({
        id: col.id.toString(),
        header: () => <p>{col.columnHeader}</p>,
        cell: (info) => {
          const rowData = info.row.original;
          const value = col.accessorFn(rowData);
          return value;
        },
      })
    );
  }, [columnData]);

  return columns;
}
